import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product-hunt-fill",
  "use": "icon-product-hunt-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-product-hunt-fill\">\n    <g>\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path d=\"M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm1.334-10H10.5V9h2.834a1.5 1.5 0 0 1 0 3zm0-5H8.5v10h2v-3h2.834a3.5 3.5 0 0 0 0-7z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol